export default __webpack_public_path__ + "static/media/popup_kwho.bc17fbdc.png";